<template>
  <div :id="id" class="cadastro-fases-wrapper">
    <TrfButton
      nome="Nova fase"
      :temIcon="true"
      classIcon="mdi-plus-thick"
      classCor="is-primary"
      width="115px"
      height="22px"
      fontSize="12px"
      type="button"
      :disabled="false"
      @click="doNovaFase"
    />
    <div class="content-fase mt-3" :class="{ 'is-open': isActive }">
      <div class="columns is-flex-direction-row is-multiline is-form mb-5">
        <div class="column is-one-fifth">
          <TrfNumberInput
            @update:modelValue="
              (value) => {
                ordem = value;
              }
            "
            :desabilitarDecimal="true"
            v-model="ordem"
            label="Ordem"
            placeholder="Digite"
            ref="inputOrdemFase"
            id="input-ordem-fase"
            maxLength="2"
            min="1"
            max="99"
            :required="isEnabled"
          />
        </div>

        <div class="column is-four-fifths">
          <TrfInput
            label="Fase"
            placeholder="Fase"
            id="titulo-fase"
            maxLength="100"
            ref="inputFaseTitulo"
            v-model="nomeFase"
            @keyup="emiteAjustePosicao"
            :required="isEnabled"
          />
        </div>

        <div class="column is-full">
          <label>Descrição</label>
          <TrfToolbarTextEditor
            v-if="descricao.isTextAtivo && isActive"
            id="text-editor-fase"
            :tipLabel="tipLabelDescricao"
            :maxlength="descricao.maxLength"
            @changeText="doChangeDescricao"
            @ready="doReadyDescricaoText"
            ref="descricaoText"
          ></TrfToolbarTextEditor>
        </div>

        <div class="column is-full">
          <TrfSelect
            :options="listaDepartamentosFase"
            label="Departamento"
            idSelect="select-departamento-fase"
            @valueSelect="(value) => (departamentoId = value)"
            @clear="() => (departamentoId = null)"
            placeholder="Selecione"
            ref="selectDepartamento"
            :canClear="true"
            :disabled="loadingCampoDepartamento"
            :loadingData="loadingCampoDepartamento"
          />
        </div>

        <div class="column is-full">
          <TrfSelect
            :options="responsaveis"
            label="Responsável"
            idSelect="select-fase-responsavel"
            @valueSelect="(value) => (responsavelId = value)"
            @clear="() => (responsavelId = null)"
            placeholder="Selecione"
            ref="selectResponsavelFase"
            :canClear="true"
            :disabled="loading.campoResponsavel"
            :loadingData="loading.campoResponsavel"
          />
        </div>

        <div v-if="checkboxNotificarConclusao" class="column is-full">
          <TrfCheckbox
            label="Notificar o cliente sobre o encerramento da fase de legalização."
            microcopia="Ao marcar esta opção, o cliente será notificado quando a fase referente ao processo de legalização for concluída."
            v-model="notificarConclusao"
          />
        </div>

        <div class="column is-full">
          <TrfRadioFields
            :listaDeOpcoes="this.opcoesTipoBaixaFase"
            class="is-fullwidth"
            id="selecao-tipo-baixa-fase"
            name="tipo-baixa-fase"
            :required="true"
            titulo="Baixa da fase"
            ref="radioTipoBaixaFase"
            @update:valorSelecionado="
              (novoValor) => {
                tipoDeBaixaFaseSelecionada = novoValor;
              }
            "
          />
        </div>

        <div class="column is-full" v-if="tipoDeBaixaFaseSelecionada == enumTipoBaixaFaseEnum.AUTOMATICA">
          <TrfSelect
            :options="referenciasDocumentoAsOptions"
            label="Documento Padrão"
            idSelect="select-documento-referencia-fase"
            @valueSelect="(value) => selecionarDocumentoReferencia(value)"
            placeholder="Selecione"
            ref="selectFaseDocumentoReferencia"
            :disabled="loading.campoReferenciasDocumentos"
            :loadingData="loading.campoReferenciasDocumentos"
            :required="isEnabled && tipoDeBaixaFaseSelecionada == enumTipoBaixaFaseEnum.AUTOMATICA"
          />
          <p class="is-size-8">
            Para saber quais documentos geram a baixa automática
            <a
              href="https://ajuda.alterdata.com.br/packupbase/tema-etarefas/etarefas-baixa-automatica-envios-que-geram-a-baixa-automatica-da-tarefa"
              target="_blank"
              >clique aqui.</a
            >
          </p>
        </div>

        <div v-if="tipoDeBaixaFaseSelecionada == enumTipoBaixaFaseEnum.PERSONALIZADA" class="column is-full">
          <TrfAutocomplete
            label="Baixa Personalizada"
            placeholder="Titulo para baixa personalizada"
            id="baixa-personalizada-fase"
            maxLength="100"
            ref="inputFaseBaixaPersonalizada"
            v-model="referenciaBaixaPersonalizada"
            @keyup="emiteAjustePosicao"
            :items="sugestoesTrechos"
            @update:modelValue="
              (value) => {
                referenciaBaixaPersonalizada = value;
              }
            "
            @update:results="async ($event) => await adquirirTrechosBaixasPersonalizadasFases()"
            :isLoading="loading.campoTrechoBaixa"
            :habilitarOpcoes="utilizaAutoComplete"
            :required="isEnabled && tipoDeBaixaFaseSelecionada == enumTipoBaixaFaseEnum.PERSONALIZADA"
          />
        </div>
      </div>
      <div class="is-flex is-justify-content-flex-end">
        <TrfButton
          :nome="faseEmEdicao != null ? 'Editar' : 'Adicionar'"
          :temIcon="true"
          classIcon="mdi-plus-thick"
          classCor="is-light"
          id="btn-adicionar"
          width="115px"
          height="22px"
          fontSize="12px"
          type="button"
          :disabled="false"
          @click="async ($event) => await montarObjetoFase($event)"
        />
        <TrfButton
          nome="Cancelar"
          :temIcon="true"
          classIcon="mdi-minus-thick"
          classCor="is-light"
          width="115px"
          height="22px"
          fontSize="12px"
          type="button"
          :disabled="false"
          @click="doFecharModal"
        />
      </div>
    </div>
    <div class="notification is-danger is-light mt-4 px-3 py-2" v-if="isFaseVazia">Adicione fases em sua tarefa.</div>
    <div class="notification is-danger is-light mt-4 px-3 py-2" v-if="exibeMensagemOrdem">A ordem das fases não é valida.</div>
    <div class="pt-2" v-if="listagemFases.length">
      <label>Fluxo da tarefa</label>
      <TrfTable
        :tipoTabela="'tabela-fases'"
        :dataConfig="this.dataSourceFase"
        :data="listagemFases"
        :isButtonMoreHidden="true"
        :showDropdownOptions="true"
        :showButtonsDefault="false"
        dataStatus=""
        :isScrollable="true"
        :shouldIgnorePreDelete="true"
        :isSelectable="false"
        :showEdit="true"
        :showDelete="true"
      >
        <template #departamentoId="{ item }">
            <p>
              {{ exibirDepartamentoTabelaFase(item) }}
            </p>
        </template>
        <template #responsavelId ="{ item }">
          <p>
            {{ exibirNomeDoResponsavelTabelaFase(item) }}
          </p>
        </template>    
        <template #nomeDaBaixa="{ item }">
          <p class="has-text-centered">
            <font-awesome-icon :icon="['fas', adquirirIconeTipoBaixaFase(item)]" :title="adquirirTextoTipoBaixaFase(item)" class="is-size-5" />
          </p>
        </template>
        <template #documentoReferenciaId="{ item }">
          <p>
            {{ adquirirNomeReferenciaTabela(item.documentoReferenciaId) }}
          </p>
        </template>
      </TrfTable>
    </div>
  </div>
</template>

<script>
import { defineAsyncComponent } from 'vue';

import { tipoBaixaFaseEnum } from '../../enums/tipoBaixaFaseEnum.js';

import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

library.add(fas);

export default {
  name: 'CadastroDeFases',
  components: {
    TrfRadioFields: defineAsyncComponent(() => import('../RadioFields/index.vue')),
    TrfInput: defineAsyncComponent(() => import('../Input/index.vue')),
    TrfButton: defineAsyncComponent(() => import('../Button/index.vue')),
    TrfNumberInput: defineAsyncComponent(() => import('../Input/TrfNumberInput.vue')),
    TrfSelect: defineAsyncComponent(() => import('../Select/index.vue')),
    TrfTable: defineAsyncComponent(() => import('../Table/index.vue')),
    TrfAutocomplete: defineAsyncComponent(() => import('../Input/TrfAutocomplete.vue')),
    TrfCheckbox: defineAsyncComponent(() => import('../Checkbox/index.vue')),
    TrfToolbarTextEditor: defineAsyncComponent(() => import('../../components/ToolbarTextEditor/index.vue')),
    FontAwesomeIcon
  },
  emits: ['update:lista-fases', 'update:posicao-switcher', 'error:fases-ordem-invalida', 'error:objeto-invalido'],
  props: {
    id: {
      type: [String],
      default: 'trf-cadastro-fase'
    },
    tiposDeBaixa: {
      type: [Array],
      default: new Array('manual', 'automatica', 'personalizada')
    },
    isEnabled: {
      type: [Boolean],
      default: false
    },
    responsaveis: {
      type: [Array],
      default: new Array()
    },
    listagemRecebida: {
      type: [Array],
      default: new Array()
    },
    utilizaAutoComplete: {
      type: [Boolean],
      default: true
    },
    isEdicao: {
      type: [Boolean],
      default: false
    },
    listaDepartamentosFase: {
      type: Array,
      required: false,
    },
    loadingCampoDepartamento: {
      type: [Boolean],
      default: false
    },
    atributosCadastro: {
      type: Object
    },
    checkboxNotificarConclusao: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isActive: false,
      documentosReferencia: [],
      sugestoesTrechos: [],
      enumTipoBaixaFaseEnum: tipoBaixaFaseEnum,
      tipoDeBaixaFaseSelecionada: tipoBaixaFaseEnum.MANUAL,
      ordem: '',
      nomeFase: '',
      responsavelId: '',
      departamentoId: '',
      notificarConclusao: this.checkboxNotificarConclusao,
      faseUuid: null,
      baixaPersonalizadaTexto: '',
      referenciaBaixaPersonalizada: '',
      formFaseActive: false,
      trechosBaixasPersonalizadas: [],
      documentoReferenciaFase: null,
      fasePossuiBaixa: false,
      faseEmEdicao: null,
      isFaseVazia: false,
      isOrdemFaseInvalida: false,
      dataSourceFase: {
        columns: [
          {
            name: 'ordem',
            label: 'Ordem',
            style: 'width: 10%;'
          },
          {
            name: 'nome',
            label: 'Fase',
            style: 'width: 20%;'
          },
          {
            name: 'departamentoId',
            label: 'Departamento',
            style: 'width: 20%;',
            slot: true
          },
          {
            name: 'responsavelId',
            label: 'Responsável',
            style: 'width: 20%;',
            slot: true
          },
          {
            name: 'nomeDaBaixa',
            label: 'Baixa da fase',
            style: 'width: 30%;',
            slot: true
          }
        ],
        itens: [],
        itensSelected: [],
        itensDisabled: [],
        select: async (item, event, index) => await this.editarFase(item, event, index),
        delete: async (item, event, index) => this.removerFase(item, event, index)
      },
      listagemFases: Array.isArray(this.listagemRecebida)? Array.from(this.listagemRecebida) : [],
      loading: {
        campoResponsavel: false,
        campoDepartamento: false,
        campoReferenciasDocumentos: true,
        campoTrechoBaixa: true,
      },
      descricao: {
        maxLength: 5000,
        plainText: '',
        html: '',
        isTextAtivo: true
      }
    };
  },
  watch: {
    isEdicao: {
      immediate: true,
      handler(novoValor, antigoValor) {
        if (novoValor === true && novoValor != antigoValor) {
          this.isOrdemFaseInvalida = !this.isOrdemFaseValida(this.listagemRecebida);
        }
      }
    },
    listagemRecebida: {
      immediate: true,
      handler(novoValor, antigoValor) {
        if (novoValor == antigoValor) return;
        let novoClone = Array.isArray(novoValor) ? Array.from(novoValor).sort() : novoValor;
        let antigoClone = Array.isArray(antigoValor) ? Array.from(antigoValor).sort() : antigoValor;
        if (
          (Array.isArray(novoClone) && Array.isArray(antigoClone) && novoClone.every((valor, index) => valor == antigoClone[index]) && antigoClone.every((valor, index) => valor == novoClone[index])) ||
          (!Array.isArray(novoClone) && novoClone != antigoClone)
        ) {
          return;
        }
        this.listagemFases = Array.from(this.listagemRecebida);
      },
      deep: true
    },
    listagemFases: {
      immediate: true,
      handler(novoValor, antigoValor) {
        let novoClone = Array.isArray(novoValor) ? Array.from(novoValor).sort() : novoValor;
        let antigoClone = Array.isArray(antigoValor) ? Array.from(antigoValor).sort() : antigoValor;

        if (
          (Array.isArray(novoClone) && Array.isArray(antigoClone) && novoClone.every((valor, index) => valor == antigoClone[index]) && antigoClone.every((valor, index) => valor == novoClone[index])) ||
          (!Array.isArray(novoClone) && novoClone != antigoClone)
        ) {
          return;
        }
        this.$emit('update:lista-fases', this.listagemFases);
      },
      deep: true
    }
  },
  computed: {
    tipLabelDescricao() {
      let count = this.descricao.maxLength;
      if(this.descricao.plainText) {
        count -= this.descricao.plainText.length;
      }
      return `Adicione informações complementares à fase, caso necessário - ${count} caracteres restantes.`;
    },
    referenciasDocumentoAsOptions() {
      if (!!!this.documentosReferencia) return [];
      const options = this.documentosReferencia.map((referencia) => {
        return {
          label: referencia.nomePadraoTarefa,
          value: referencia.id
        };
      });
      return options;
    },
    exibeMensagemOrdem() {
      return this.isEdicao && !this.isOrdemFaseValida();
    },
    opcoesTipoBaixaFase() {
      if (!Array.isArray(this.tiposDeBaixa)) return [];

      const opcoesTipoBaixaFase = [];
      if (this.tiposDeBaixa.includes('manual')) {
        opcoesTipoBaixaFase.push({
          id: 'radio-baixa-manual',
          label: 'Conclusão manual',
          default: true,
          valor: tipoBaixaFaseEnum.MANUAL
        });
      }
      if (this.tiposDeBaixa.includes('automatica')) {
        opcoesTipoBaixaFase.push({
          id: 'radio-baixa-automatica',
          label: 'Envio automático do documento',
          valor: tipoBaixaFaseEnum.AUTOMATICA,
          tip: 'Selecione esta opção caso a fase possua baixa automática a partir do envio de documentos pelos sistemas Desktop da linha Pack ou UpDocs.'
        });
      }
      if (this.tiposDeBaixa.includes('personalizada')) {
        opcoesTipoBaixaFase.push({
          id: 'radio-baixa-personalizada',
          label: 'Baixa personalizada',
          valor: tipoBaixaFaseEnum.PERSONALIZADA
        });
      }

      return opcoesTipoBaixaFase;
    }
  },
  methods: {
    async adquirirTrechoBaixaPersonalizadaService() {
      const { trechoBaixaPersonalizadaService } = await import('../../service/trecho-baixa-personalizada.js');
      return trechoBaixaPersonalizadaService;
    },
    async adquirirToastUtils() {
      const { toastUtils } = await import('../../util/toast.utils.js');
      return toastUtils;
    },
    async adquirirReferenciasDocumentosService() {
      const { referenciasDocumentosService } = await import('../../service/referencias-documento-service.js');
      return referenciasDocumentosService;
    },
    selecionarDocumentoReferencia(valor) {
      const documentoReferenciaFase = this.documentosReferencia.find((referencia) => {
        return referencia.id == valor;
      });
      this.documentoReferenciaFase = Object.assign({}, documentoReferenciaFase);
    },
    async adquirirTrechosBaixasPersonalizadasFases() {
      if(this.tiposDeBaixa.includes('personalizada') && this.utilizaAutoComplete) {
        await this.adquirirTrechosBaixasPersonalizadas(this.referenciaBaixaPersonalizada);
      }
    },
    async adquirirTrechosBaixasPersonalizadas(textoBusca) {
      try {
        const trechoBaixaPersonalizadaService = await this.adquirirTrechoBaixaPersonalizadaService();
        trechoBaixaPersonalizadaService.abortarUltimoRequest('get');
        this.loading.campoTrechoBaixa = true;
        const lista = await trechoBaixaPersonalizadaService.listarReferencias(textoBusca);
        this.sugestoesTrechos = lista.data.map((trecho) => {
          return trecho.nomePadrao;
        });
        this.loading.campoTrechoBaixa = false;
      } catch (e) {
        console.warn('WARN:', e);
        this.loading.campoTrechoBaixa = false;
      }
    },
    emiteAjustePosicao() {
      this.$emit('update:posicao-switcher', true);
    },
    async adquirirReferenciasDocumentos() {
      const referenciasDocumentosService = await this.adquirirReferenciasDocumentosService();
      try {
        this.loading.campoReferenciasDocumentos = true;
        this.documentosReferencia = await referenciasDocumentosService.listarReferencias();
        this.loading.campoReferenciasDocumentos = false;
      } catch (e) {
        console.warn('WARN:', e);
        this.loading.campoReferenciasDocumentos = false;
      }
    },
    async montarObjetoFase() {
      if (this.validarObjetoDeFase()) {
        const toastUtils = await this.adquirirToastUtils();
        toastUtils.dangerToast('Existem campos não preenchidos');
        this.$emit('error:objeto-invalido', true);
        return;
      }

      const objetoMontado = {
        ordem: parseInt(this.ordem),
        nome: this.nomeFase,
        responsavelId: this.responsavelId,
        departamentoId: this.departamentoId,
        notificarConclusao: this.notificarConclusao,
        descricao: this.descricao.html
      };

      if (this.faseEmEdicao != null) {
        objetoMontado.deveAtualizarResponsavel = this.listagemFases[this.faseEmEdicao].deveAtualizarResponsavel;
      } 

      if (this.tipoDeBaixaFaseSelecionada == tipoBaixaFaseEnum.AUTOMATICA) {
        objetoMontado.documentoReferenciaId = Number(this.documentoReferenciaFase.id);
      } else {
        this.documentoReferenciaFase = null;
      }

      if (this.tipoDeBaixaFaseSelecionada == tipoBaixaFaseEnum.PERSONALIZADA) {
        objetoMontado.referenciaBaixaPersonalizada = this.referenciaBaixaPersonalizada;
      } else {
        this.referenciaBaixaPersonalizada = null;
      }

      if (this.faseUuid != null) {
        objetoMontado.uuid = this.faseUuid;
      }

      const objetoSemReferencia = Object.assign({}, objetoMontado);
      const novaArrayDeDados = [...this.listagemFases];

      if (this.faseEmEdicao != null) {
        novaArrayDeDados[this.faseEmEdicao] = objetoSemReferencia;
      } else {
        novaArrayDeDados.push(objetoSemReferencia);
      }

      novaArrayDeDados.sort((a, b) => {
        if (a.ordem !== b.ordem) {
          return a.ordem - b.ordem;
        }
        if (a.nome < b.nome) return -1;
        if (a.nome > b.nome) return 1;
        return 0;
      });

      this.listagemFases = novaArrayDeDados;
      this.limparCamposFase();
      this.isFaseVazia = false;
      this.isOrdemFaseInvalida = !this.isOrdemFaseValida();
    },
    valid() {
      return this.validarObjetoDeFase() && !this.isOrdemFaseInvalida;
    },
    validarObjetoDeFase() {
      let tipoDeBaixaValida = true;
      if (!!!this.ordem) {
        this.$refs.inputOrdemFase.verificarSeInputEstaVazio();
      }
      if (!!!this.nomeFase) {
        this.$refs.inputFaseTitulo.verificarSeInputEstaVazio();
      }
      if (this.tipoDeBaixaFaseSelecionada == tipoBaixaFaseEnum.AUTOMATICA) {
        this.$refs.selectFaseDocumentoReferencia.verificarSeInputEstaVazio();
        tipoDeBaixaValida = !!this.documentoReferenciaFase;
      } else if (this.tipoDeBaixaFaseSelecionada == tipoBaixaFaseEnum.PERSONALIZADA) {
        this.$refs.inputFaseBaixaPersonalizada.verificarSeInputEstaVazio();
        tipoDeBaixaValida = !!this.referenciaBaixaPersonalizada;
      }

      return !!!this.ordem || !!!this.nomeFase || !!!tipoDeBaixaValida;
    },
    limparCamposFase() {
      this.ordem = '';
      this.nomeFase = '';
      this.responsavelId = null;
      this.departamentoId = null;
      this.referenciaBaixaPersonalizada = '';
      this.limparCamposDepartamentoEResponsavel();

      if (this.tipoDeBaixaFaseSelecionada == tipoBaixaFaseEnum.AUTOMATICA) {
        this.documentoReferenciaFase = null;
        this.$refs.selectFaseDocumentoReferencia.limparSelect();
        this.$refs.selectFaseDocumentoReferencia.limparValidacao();
      }

      this.faseUuid = null;

      if (!!this.$refs.radioTipoBaixaFase) {
        this.$refs.radioTipoBaixaFase._selecionarDefault();
      }
      this.tipoDeBaixaFaseSelecionada = tipoBaixaFaseEnum.MANUAL;

      this.faseEmEdicao = null;

      this.limparDescricao();
    },
    limparListagemFases() {
      this.listagemFases = [];
    },
    isOrdemFaseValida(lista = this.listagemFases) {
      const fases = [...lista];

      if (fases.length == 0) return false;

      fases.sort((a, b) => {
        if (a.ordem < b.ordem) {
          return -1;
        } else {
          return true;
        }
      });

      const peloMenosUmItemPrimeiro = fases.some((fase) => {
        return fase.ordem == 1;
      });

      const validacaoFases = [];

      fases.forEach((fase, index) => {
        let validade;
        if (index == 0) {
          validade = fase.ordem == 1;
        } else {
          validade = fase.ordem == fases[index - 1].ordem || fase.ordem - 1 == fases[index - 1].ordem;
        }
        validacaoFases.push(validade);
      });

      const validacao = validacaoFases.every((result) => {
        return result == true;
      });

      this.$emit('error:fases-ordem-invalida', !(peloMenosUmItemPrimeiro && validacao));
      return peloMenosUmItemPrimeiro && validacao;
    },
    removerFase(item, event, index) {
      this.listagemFases = this.listagemFases.filter((_, i) => i !== index);
      this.isOrdemFaseInvalida = !this.isOrdemFaseValida();
      if (this.faseEmEdicao == index) {
        this.faseEmEdicao = null;
      }
    },
    async editarFase(item, event, index) {
      if (!this.isActive) {
        this.isActive = true;
        await this.$nextTick();
      }
      
      const itemEmAlteracao = this.listagemFases[index];
      this.faseEmEdicao = index;
      this.formFaseActive = true;

      this.limparCamposDepartamentoEResponsavel();

      this.ordem = `${itemEmAlteracao.ordem}`;
      this.nomeFase = itemEmAlteracao.nome;

      const responsavel = itemEmAlteracao.responsavelId ? itemEmAlteracao.responsavelId : null;
      this.$refs.selectResponsavelFase.iniciarSelectComValor(responsavel);
      this.responsavelId = itemEmAlteracao.responsavelId;

      const dp = itemEmAlteracao.departamentoId ? itemEmAlteracao.departamentoId.toString() : null;
      this.$refs.selectDepartamento.iniciarSelectComValor(dp);
      this.departamentoId = itemEmAlteracao.departamentoId;

      if (item.uuid) {
        this.faseUuid = itemEmAlteracao.uuid;
      }

      if (!!itemEmAlteracao.referenciaBaixaPersonalizada) {
        this.tipoDeBaixaFaseSelecionada = tipoBaixaFaseEnum.PERSONALIZADA;
        this.$refs.radioTipoBaixaFase._selecionarPorValor(this.tipoDeBaixaFaseSelecionada);
        await this.$nextTick();
        this.referenciaBaixaPersonalizada = itemEmAlteracao.referenciaBaixaPersonalizada;
      } else if (!!itemEmAlteracao.documentoReferenciaId) {
        this.tipoDeBaixaFaseSelecionada = tipoBaixaFaseEnum.AUTOMATICA;
        this.$refs.radioTipoBaixaFase._selecionarPorValor(this.tipoDeBaixaFaseSelecionada);
        await this.$nextTick();
        this.$refs.selectFaseDocumentoReferencia.iniciarSelectComValor(itemEmAlteracao.documentoReferenciaId);
        this.selecionarDocumentoReferencia(itemEmAlteracao.documentoReferenciaId);
      }

      this.notificarConclusao = itemEmAlteracao.notificarConclusao;
      
      this.setDescricao(itemEmAlteracao.descricao);
    },
    async setDescricao(descricaoHtml) {
      const descricaoHtmlTratada = descricaoHtml == null ? '' : descricaoHtml;

      if(!this.$refs.descricaoText) {
        this.descricao.html = descricaoHtmlTratada;
        return;
      }

      this.$refs.descricaoText.iniciarTextEditorComValor(descricaoHtmlTratada);
      await this.$nextTick();
      this.descricao.html = descricaoHtmlTratada;
      this.descricao.plainText = this.$refs.descricaoText
        ? this.$refs.descricaoText.getValueAsText()
        : '';
    },
    async limparDescricao() {
      this.descricao.isTextAtivo = false;
      await this.$nextTick();
      this.descricao.isTextAtivo = true;

      this.descricao.html = '';
      this.descricao.plainText = '';
    },
    limparCamposDepartamentoEResponsavel() {
      this.$refs.selectResponsavelFase.limparSelect();
      this.$refs.selectResponsavelFase.limparValidacao();
      this.$refs.selectDepartamento.limparSelect();
      this.$refs.selectDepartamento.limparValidacao();
    },
    exibirNomeDoResponsavelTabelaFase(item) {
      if (!!!item.responsavelId) return "---"
      const responsavel = this.responsaveis.find((responsavel) => {
        return responsavel.value == item.responsavelId;
      });
      return !!!responsavel?.label ? "---" : responsavel.label;
    },
    exibirDepartamentoTabelaFase(item) {
      if (!!!item.departamentoId) {
        item.departamentoId = this.atributosCadastro.departamentoId;
      }
      const departamento = this.listaDepartamentosFase.find((departamento) => {
        return departamento.value == item.departamentoId;
      });
      return !!!departamento?.label ? "---" : departamento.label;
    },
    adquirirIconeTipoBaixaFase(item) {
      let iconeBaixa = 'user-check';
      if (!!item.documentoReferenciaId && item.documentoReferenciaId != null) {
        iconeBaixa = 'file-circle-check';
      } else if (!!item.referenciaBaixaPersonalizada && item.referenciaBaixaPersonalizada != '') {
        iconeBaixa = 'file-circle-check';
      }
      return iconeBaixa;
    },
    adquirirTextoTipoBaixaFase(item) {
      let textoBaixa = 'Conclusão manual';
      if (!!item.documentoReferenciaId && item.documentoReferenciaId != null) {
        textoBaixa = this.adquirirNomeReferenciaTabela(item.documentoReferenciaId);
      } else if (!!item.referenciaBaixaPersonalizada && item.referenciaBaixaPersonalizada != '') {
        textoBaixa = item.referenciaBaixaPersonalizada;
      }
      return textoBaixa;
    },
    adquirirNomeReferenciaTabela(id) {
      if (!!!this.documentosReferencia) return '---';

      const referencia = this.documentosReferencia.find((referencia) => {
        return referencia.id == id;
      });

      return referencia ? referencia.nomePadraoTarefa : '---';
    },
    doChangeDescricao(value) {
      const plainText = this.$refs.descricaoText.getValueAsText();
      if(plainText.length > this.descricao.maxLength) {
        return;
      }

      this.descricao.html = value;
      this.descricao.plainText = this.$refs.descricaoText.getValueAsText();
    },
    doReadyDescricaoText() {
      this.setDescricao(this.descricao.html);
    },
    async doNovaFase() {
      this.isActive = !this.isActive;
      await this.$nextTick();
      this.limparDescricao();
    },
    doFecharModal() {
      this.limparCamposFase();
      this.formFaseActive = false;
    }
  },
  async mounted() {
    if (this.tiposDeBaixa.includes('automatica')) {
      await this.adquirirReferenciasDocumentos();
    }
    if(this.tiposDeBaixa.includes('personalizada') && this.utilizaAutoComplete) {
      await this.adquirirTrechosBaixasPersonalizadas();
    }
  }
};
</script>
<style lang="scss" scoped>
#btn-adicionar {
  margin-right: 5px;
}
.content-fase {
  overflow: hidden;
  max-height: 0;
  opacity: 0;
  transition: max-height 0.35s ease-in 0s, opacity 0.25s ease-in 0.1s;
  &.is-open {
    max-height: 1000vh;
    transition: max-height 0.35s ease-out 0s, opacity 0.25s ease-out 0.1s;
    opacity: 1;
    overflow: visible;
  }
}
.columns.is-form {
  .column {
    padding-bottom: 0 !important;
  }
}
.tip-label-grupo {
  font-style: italic;
  font-size: 12px;
}
</style>
